<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
      <a-card>
        <div slot="title"><a-icon type="file-search" />&nbsp;Search</div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search
              v-model="search"
              :disabled="triggerSearch"
              placeholder="Quick Search"
            />
          </li>
          <li>
            <a-collapse :activeKey="getScreen ? 0 : 1">
              <a-collapse-panel key="1">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Transaction Date</label>
                  <a-date-picker
                    placeholder="Select Date"
                    v-model="searchDate"
                    :disabled="triggerSearch"
                    :format="getDefaultDateFormat"
                    allowClear
                  />
                </div>

                <div class="m-form-item-wrapper">
                  <label for="currency">Currency</label>
                  <a-select
                    placeholder="Choose Currency"
                    v-model="currency"
                    :disabled="triggerSearch"
                    class="width-full"
                    initialValue="undefined"
                    allowClear
                  >
                    <a-select-option
                      v-for="item in getAllMataUang"
                      :key="item.code"
                      :value="item.code"
                      >{{ item.code }} - {{ item.currency }}</a-select-option
                    >
                  </a-select>
                </div>

                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Status</label>
                  <a-select
                    placeholder="Ex: Approved ... "
                    v-model="status"
                    :disabled="triggerSearch"
                    class="width-full"
                    initialValue="delivered"
                    allowClear
                  >
                    <a-select-option
                      v-for="item in getStatus"
                      :key="item.id"
                      :value="item.value"
                      >{{ item.label }}</a-select-option
                    >
                  </a-select>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
      <DataListSlot
        title="Other Income"
        manifestLink="OtherIncomeManifestKeu"
        createLink="createOtherIncome"
        :disabledCreateEditLink="false"
        :fileStatus="true"
        :dataList="searching"
      >
        <div
          class="m-display-flex flex-row space-between"
          slot="status_file"
          slot-scope="data"
        >
          <template
            v-if="data.item.bkm_generated != 0"
          >
            <span class="margin-remove">BKM</span>
            <a-tag class="margin-remove">
              {{
                data.item.bkm_generated == 1 && data.item.is_uploaded == 0
                  ? "No File Uploaded"
                  : "File Have Been Uploaded"
              }}
            </a-tag>
          </template>
        </div>
      </DataListSlot>

      <!-- <DataList
        :loading="loading"
        title="Other Income"
        manifestLink="OtherIncomeManifestKeu"
        :dataList="searching"
        :price="true"
        :disabledCreateEditLink="false"
        :isMonitoring="true"
        createLink="createOtherIncome"
      /> -->
    </a-col>
  </a-row>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import _ from "lodash";

export default {
  name: "ListOtherIncome",
  props: ["prnMenu"],
  mixins: [CurrencyFormat],
  data() {
    return {
      loading: true,
      dataList: [],
      basedList: [],
      listDirector: [],
      searchDate: null,
      search: "",
      status: undefined,
      currency: undefined,
      triggerSearch: false,
    };
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getStatus",
      "getAllMataUang",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
    searching() {
      var self = this;
      let outputData = this.dataList;

      if (this.search) {
        outputData = _.filter(
          outputData,
          (obj) =>
            obj.searchQ.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }

      if (this.searchDate) {
        let filter = moment(this.searchDate).format(this.getDefaultDateFormat);

        outputData = _.filter(outputData, { tgl_buat: filter });
      }

      if (this.currency) {
        outputData = outputData.filter(
          (obj) =>
            obj.currency &&
            obj.currency.toLowerCase().indexOf(self.currency.toLowerCase()) >= 0
        );
      }

      if (this.status) {
        outputData = _.filter(
          outputData,
          (obj) =>
            obj.status && obj.status.toLowerCase().indexOf(self.status) >= 0
        );
      }

      return outputData;
    },
  },
  created() {
    this.fetchData();
    this.$store.dispatch("FETCH_ALL_MATA_UANG");
  },
  mounted() {
    Event.$on("callbackTab", this.clickTabed);
  },
  beforeDestroy() {
    Event.$off("callbackTab", this.clickTabed);
  },
  methods: {
    moment,
    fetchData() {
      // monitoring/klaim_direktur
      // id: localStorage.getItem("nvky"),
      axios({
        method: "get",
        url: this.$serviceUrl + "other_income",
        params: {
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      }).then((response) => {
        _.forEach(response.data.data, (data) => {
          this.dataList.push({
            title: data.no_other_income+' | '+data.tlc,
            timeline: JSON.parse(data.status_app),
            subdesc: {
              pembuat: data.receive_from,
              deskripsi: data.deskripsi,
              tanggal: moment(data.tanggal).format(this.getDefaultDateFormat),
              price: this.formatCurrency(data.currency, data.value),
            },
            bkm_generated: data.bkm_generated,
            is_uploaded: data.doc_uploaded,
            status: data.status,
            currency: data.currency,
            id: data.id_other_income,
            price: this.formatCurrency(data.currency, data.value),
            tgl_buat: moment(data.tanggal).format(this.getDefaultDateFormat),
            searchQ:
              data.no_other_income +
              " " +
              data.deskripsi +
              " " +
              data.tlc +
              " " +
              data.receive_from +
              " " +
              data.value,
          });
        });

        this.loading = false;
      });
    },
    clickTabed(val) {
      this.search = "";
      this.searchDate = undefined;
      this.currency = undefined;
      this.status = undefined;
      if (val == "draft") {
        this.triggerSearch = true;
      } else {
        this.triggerSearch = false;
      }
    },
  },
};
</script>

<style></style>
